<script setup lang="ts">
import { useModelTable } from './../model/model'
import { VIcons } from '@/shared/ui'
import {
  AdminConfiguratorButton,
  AdminConfiguratorDelete,
  AdminConfiguratorForm,
  AdminConfiguratorMove,
} from '@/features/Cabinet'
import { AdminConfiguratorTemplates } from '@/entities/Cabinet/AdminConfiguratorTemplates'
import { AdminConfiguratorTemplateForm } from '@/features/Cabinet/AdminConfiguratorTemplate'
import { computed } from 'vue'

const store = useModelTable()
const { isPending, refetch } = store.loadTable()

/* Исключаем пины из списка */
const excludePins = [100]
const configList = computed(() =>
  store.configs.filter((item) => !excludePins.includes(item.pin_number)),
)
</script>

<template>
  <VDataTable
    :items="configList"
    :loading="isPending"
    :headers="store.headers"
    items-per-page="50"
    density="comfortable"
  >
    <template v-slot:item.index="{ index }">
      {{ index + 1 }}
    </template>

    <template v-slot:item.action="{ item, index }">
      <div class="flex-table__button">
        <AdminConfiguratorButton :item>
          <VBtn icon density="compact">
            <VIcons type="settings" />
          </VBtn>
        </AdminConfiguratorButton>

        <AdminConfiguratorDelete :item @updated="refetch" />

        <AdminConfiguratorMove :items="store.configs" :index="index" :item @updated="refetch" />
      </div>
    </template>
  </VDataTable>

  <div class="mt-2 form__btn_left">
    <AdminConfiguratorButton>
      <VBtn>{{ $t('itf.add') }}</VBtn>
    </AdminConfiguratorButton>

    <AdminConfiguratorTemplates :configs="store.configs" />
  </div>

  <AdminConfiguratorForm :items="store.configs" :events="store.events" @updated="refetch" />
  <AdminConfiguratorTemplateForm :events="store.events" />
</template>
